// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3knHW","log":"ModalInventoryLogs_log__VWGgf","date":"ModalInventoryLogs_date__2GbyM","userName":"ModalInventoryLogs_userName__29MkM"};